import {
  input,
  InputSignal,
  HostBinding,
  OnChanges,
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  output,
  OutputEmitterRef,
  contentChild,
  Signal
} from '@angular/core';

import { IconButtonComponent } from '../../components/icon-button/icon-button.component';
import { IconComponent } from '../../components/icon/icon.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

export type CallOutType = 'primary' | 'secondary';

export type CallOutSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'td-wb-call-out',
  templateUrl: './call-out.component.html',
  styleUrls: ['./call-out.component.scss'],
  imports: [
    IconButtonComponent,
    IconComponent,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallOutComponent implements OnChanges, AfterContentInit {
  private static readonly CALL_OUT_ROW: string = 'row';

  readonly icon: Signal<IconComponent | undefined> = contentChild(IconComponent);

  type: InputSignal<CallOutType> = input<CallOutType>('primary');
  size: InputSignal <CallOutSize> = input<CallOutSize>('small');
  layout: InputSignal <string> = input<string>(CallOutComponent.CALL_OUT_ROW);
  dismissible: InputSignal <boolean> = input<boolean>(false);
  borderWidth: InputSignal <number | undefined> = input<number | undefined>(undefined);
  close: OutputEmitterRef<void> = output<void>();

  @HostBinding('class.td-wb-call-out--row')
  get callOutRow(): boolean {
    return this.layout() === CallOutComponent.CALL_OUT_ROW;
  }

  @HostBinding('class.td-wb-call-out--dismissible')
  get isDismissible(): boolean {
    return this.dismissible();
  }

  @HostBinding('class.td-wb-call-out--small') small: boolean = true;
  @HostBinding('class.td-wb-call-out--medium') medium: boolean = false;
  @HostBinding('class.td-wb-call-out--large') large: boolean = false;
  @HostBinding('class.td-wb-call-out--secondary') secondary: boolean = false;

  ngOnChanges(): void {
    this.small = this.size() === 'small';
    this.medium = this.size() === 'medium';
    this.large = this.isSizeLarge();
    this.secondary = this.type() === 'secondary';
  }

  ngAfterContentInit(): void {
    const icon = this.icon();
    if (icon !== undefined && icon.size === undefined) {
      icon.setIconSize(this.getIconSize());
    }
  }

  /**
   * return true if size is large
   *
   * @return large
   */
  isSizeLarge(): boolean {
    return this.size() === 'large';
  }

  /**
   * Emits close event
   */
  onClose(): void {
    this.close.emit();
  }

  /**
   * get icon size
   *
   * @return size
   */
  private getIconSize(): string {
    return this.isSizeLarge() ? '70' : '40';
  }
}
